// extracted by mini-css-extract-plugin
export default {"scoreBar":"pOxKAUcXrqUs9RU9YXQh","titleWrapper":"SNxCyanePGv3QyxdPUVM","developability":"sQ1Z1Uek9omaBW8E22zP","scoreName":"NAsjiwAVcu5UBFY3EVA8","scoreValue":"PzMz_Z3d7nixXQY387gD"};